export default class AgentInfo {

    constructor(jsonObj) {

        this.transactionCountToday = jsonObj["transaction-count-today"];
        this.transactionSumToday = jsonObj["transaction-sum-today"];
        this.transactionCountMonth = jsonObj["transaction-count-month"];
        this.transactionSumMonth = jsonObj["transaction-sum-month"];
        this.registrationCount = jsonObj["registration-count-today"];
        this.totalRegistrations = jsonObj["total-registrations"];

    }

}